import { Outlet } from 'react-router';
import type { FC, PropsWithChildren } from 'react';
import { lazy, Suspense, useEffect } from 'react';
import { getToSMask, isUserChanged } from '../utils/tokenUtils';
import { isToSAccepted } from '../utils/isToSAccepted.ts';
import { deleteAccountToken, isAuth } from '../utils/tokenServices.ts';
import Loader from '../views/common/loader/Loader.tsx';

const ModalWithTerms = lazy(() => import('../layout/ModalWithTerms'));

const FrameworkRoute: FC<PropsWithChildren> = () => {
  const tosMask = getToSMask();
  const isAccepted = isToSAccepted(0, tosMask);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onTokenChanges = (e: any) => {
    if (e.key === 'USER_TOKEN' && e.oldValue !== e.newValue) {
      if (isUserChanged(e.oldValue as string)) {
        deleteAccountToken();
        window.location.replace('/');
      }
    }
  };

  useEffect(() => {
    window.addEventListener('storage', onTokenChanges);

    return () => window.removeEventListener('storage', onTokenChanges);
  }, []);

  if (isAuth() && !isAccepted) {
    return (
      <Suspense fallback={<Loader />}>
        <ModalWithTerms />
      </Suspense>
    );
  }

  return <Outlet />;
};

export default FrameworkRoute;
